<mat-form-field
  appearance="fill"
  floatLabel="always"
  subscriptSizing="dynamic"
  [ngClass]="{
    'rkt-FormField--full-width': isFullWidth
  }"
>
  <mat-label>{{ label }}</mat-label>
  <input
    matInput
    inputmode="tel"
    placeholder="(000) 000-0000"
    type="tel"
    [attr.autocomplete]="'tel-national'"
    [attr.data-testid]="dataTestId"
    [formControl]="formControlRef"
    [mask]="!!maskOverride ? maskOverride : '(000) 000-0000'"
    [hiddenInput]="formControlRef?.pristine"
  />
  <mat-error [attr.data-testid]="dataTestId + '-error'">{{ errorMessage }}</mat-error>
</mat-form-field>
